class blogFilter extends HTMLElement {
    constructor() {
        super();
        this.mainBlog = document.querySelector("[js-main-blog]");
        this.scrollToElement = this.mainBlog.querySelector("[data-scroll-to]");
        this.sectionId = this.mainBlog.dataset.sectionId;
        
        this.init();
        document.addEventListener("blog-filter:init", this.init.bind(this));
        document.addEventListener("scroll:init", this.updateScroll.bind(this));
        document.addEventListener("loading:init", ({ detail: { loading }}) => {
            this.updateLoading(loading);
        });
        document.addEventListener("changeState", ({ detail: { target }}) => {
            this.changeActiveState(target, true);
        });
        document.addEventListener("updateHistoryState", ({ detail: { url }}) => {
            this.updateHistoryState(url);
        });
    };

    init() {
        this.filterItems = this.querySelectorAll("[js-filter-item]");

        this.filterItems.forEach( filterItem => {
            filterItem.addEventListener('click', (e) => {
                e.preventDefault();

                this.initAjaxBlog(e.currentTarget);
            })
        });
    };

    initAjaxBlog(target) {
        const tagUrl = target.querySelector("a").getAttribute("href");

        this.updateLoading(true);
        if(!target.classList.contains("is-remove-item")) {
            this.changeActiveState(target);
        };
        this.disabledFilter();
        this.updateHistoryState(tagUrl);
        this.renderAjaxBlog(tagUrl, target);
    }

    updateLoading(loading) {
        if(loading) {
            this.mainBlog.classList.add('disabled');
            this.scrollToElement.classList.add('loading');
        }else {
            this.mainBlog.classList.remove('disabled');
            this.scrollToElement.classList.remove('loading');
        }
    };

    changeActiveState(target, isClear) {
        if(isClear) {
            this.filterItems.forEach( filterItem => filterItem.classList.remove("active"));
            target.classList.add('active');
        }else {
            target.classList.toggle('active');
        }
    };

    disabledFilter() {
        this.filterItems.forEach( filterItem => filterItem.classList.add('disabled'));
    };

    updateHistoryState(TagUrl) {
        var newurl = `${window.location.protocol}//${window.location.host}${TagUrl}`;
        window.history.replaceState({path: newurl}, '', newurl);
    };

    updateScroll() {
        var scrollTo = this.scrollToElement && this.scrollToElement.offsetTop;
        window.scrollTo({top: scrollTo, behavior: 'smooth'});
    };

    renderAjaxBlog(tagUrl, target) {
        const url = `${tagUrl}?section_id=${this.sectionId}`;
        
        fetch(url).then(function(response) {
            return response.text();
        }).then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            this.updateScroll();
            if(!target.classList.contains("is-remove-item")) {
                doc.querySelector(".Blog_alternate_template_2_leftside_filter_new").classList.add("open");
            };
            this.mainBlog.innerHTML = doc.querySelector("[js-main-blog]").innerHTML;
            this.updateLoading(false);
            document.dispatchEvent(new CustomEvent("dropdown:init"));
            document.dispatchEvent(new CustomEvent("filter-drawer:init"));
        });
    }
}
  
customElements.define('blog-filter', blogFilter);